export class IframeVideoAutoplay {
  constructor(options) {
    this.videosInViewport = [];
    this.mute = true;
    this.replay = false;
    this.container = options?.container;
    this.observerOptions = {
      root: null,
      rootMargin: '20%',
      threshold: 0.1,
    };
    this.init(this.container);
  }

  init(container) {
    if (!container) return;
    container.querySelectorAll('iframe')
      .forEach((frame, index) => {
        let data = frame.closest('section')?.dataset;
          if (this._isVideoFrame(frame)) {
            if (data.urlParams?.includes('autoplay')) {
              this._addAutoplay(frame, this.mute, data);
            } else {
              this._setUrl(frame);
            }
          }
      })
  }
  _setUrl(frame) {
    const setUrlObserver = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        let iframe = entries[0].target;
        if (iframe?.dataset?.src) {
          if(window.location.href.includes('adv=0') &&
            iframe.dataset.src.includes('motorsport.tv')){
            let url = new URL(iframe.dataset.src);
            url.searchParams.append('no_ad','1');
            iframe.dataset.src = url.href;
          }
          iframe.src = iframe.dataset.src;
        }
        iframe.parentElement.classList.remove('lazy');
        setUrlObserver.unobserve(iframe);
      }
    }, this.observerOptions);
    setUrlObserver.observe(frame);
  }

  _addAutoplay(frame, mute, data) {
    const iObserver = new IntersectionObserver((entries, observer) => {
      let index = this.videosInViewport.indexOf(entries[0].target);
      if (entries[0].isIntersecting) {
        if (index === -1) {
          this.videosInViewport.push(entries[0].target);
          $(window).trigger('scroll');
        }
      } else {
        if (index >= 0) {
          this.videosInViewport.splice(index, 1);
        }
        this._play(entries[0].target, false, this.mute , data);

        if ($(entries[0].target).data('played') && !this.replay) {
          observer.disconnect();
        }
        $(window).trigger('scroll');
      }
    }, this.observerOptions);
    iObserver.observe(frame);

    $(window).on('scroll', () => {
      if (!this.videosInViewport.length) {
        return;
      }
      let index = -1;
      let currentPos = 100000;
      this.videosInViewport.forEach((e, i) => {
        let rect = e.getBoundingClientRect();
        let pos = window.innerHeight / 2 - rect.top - rect.height / 2;
        if (Math.abs(pos) < Math.abs(currentPos)) {
          currentPos = pos;
          index = i;
        }

      });

      if (index === -1) {
        return;
      }

      this.videosInViewport.forEach((e, i) => {
        this._play(e, i === index, mute, data);
      });
    });

    $(window).trigger('scroll');
  }


  _play(frame, play, mute, data) {
    if (
      play &&
      window.TRINITY_PLAYER?.players['trinity-audio-player']?.state === 'play'
    ) {
      return;
    }
    const $frame = $(frame);
    play = play !== false;
    data = data || {};

    if (!$frame.length) {
      return;
    }

    const src = $frame[0].src || $frame[0].dataset.src;

    if (!src) {
      return;
    }

    let newSrc = '';
    const isPlaying = $frame.data('playing');

    const url = new URL(src);

    if (isPlaying == undefined) {
      url.searchParams.delete('autoplay');
      url.searchParams.delete('mute');
    }

    if (play && !isPlaying) {
      url.searchParams.append('autoplay', '1');
      if (mute) {
        url.searchParams.append('mute', '1');
      }

      $frame.data('playing', true);
      $frame.data('played', true);
    } else if (!play) {
      url.searchParams.delete('autoplay');
      url.searchParams.delete('mute');
      $frame.data('playing', false);
    }
    newSrc = url.href;

    if (src !== newSrc) {
      $frame.attr('src', newSrc);
    }
  }

  _isVideoFrame(frame) {
    const src = frame.dataset?.src;

    if (!src) return false;

    if (src.includes('youtube.com')) {
      return true;
    } else if (src.includes('dailymotion.com')) {
      return true;
    } else if (src.includes('motorsport.tv')) {
      return true;
    }

    return false;
  }
}
